// Dubai - weight loss personal trainer.
const content = {
    slug: 'weight-loss-personal-trainer',
    title: 'Weight Loss Personal Trainer in Dubai | Plans Built for Dubai Life',
    description: (c) =>
        `Weight loss personal training in Dubai: strength work, realistic eating habits and a plan that survives brunches and summer. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Dubai · Weight loss',
    h1: 'Weight Loss Personal Trainer in Dubai',
    lead: 'Losing weight in Dubai means working around long summers indoors, weekend brunches, delivery apps and long commutes. A trainer builds a plan around that life - not around a perfect week that never happens.',
    image: 'diet.jpg',
    imageAlt: 'Healthy meal prepared as part of a weight loss plan',
    facts: ['Strength-led programmes', 'Eating habits, not crash diets', 'Indoor plan for summer'],
    ctaLabel: 'Start a weight loss plan',
    matchSummary: 'a weight loss personal trainer in Dubai',
    packagesTitle: 'Weight loss packages',
    packagesIntro: 'For weight loss, three sessions a week works best at the start. The 30-session package covers about ten weeks at that pace.',
    sections: [
        {
            title: 'How a Dubai weight loss plan is built',
            steps: [
                { title: 'Assessment', body: 'Weight, measurements, movement screen and a candid look at your week: work hours, commute, eating out, sleep.' },
                { title: 'Strength first', body: 'Two or three resistance sessions a week to keep muscle while you lose fat - the part most crash plans get wrong.' },
                { title: 'Steps and cardio that fit the season', body: 'Mall walks and building treadmills in summer, beach and park sessions in winter.' },
                { title: 'Eating habits', body: 'Simple targets: protein at each meal, fewer liquid calories, a plan for brunch and takeaway nights.' },
                { title: 'Check-ins', body: 'Measurements every two weeks and adjustments when progress stalls.' },
            ],
        },
        {
            title: 'The Dubai obstacles your trainer plans for',
            tone: 'muted',
            cards: [
                { title: 'Summer inactivity', body: 'From June to September, daily steps drop sharply. The plan keeps you moving indoors.' },
                { title: 'Brunch weekends', body: 'Not banned - planned. A lighter Friday and Sunday balance the Saturday out.' },
                { title: 'Delivery culture', body: 'Your trainer helps you pick better options from the apps you already use.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'How fast can I lose weight with a personal trainer?',
            answer: 'A realistic, sustainable pace is around 0.5 to 1 kg a week, faster at the start. Your trainer sets targets after the first assessment.',
        },
        {
            question: 'Do I need a gym?',
            answer: 'No. Home sessions with portable equipment work well, and most Dubai buildings have a gym your trainer can use with you.',
        },
        {
            question: 'Will you give me a diet plan?',
            answer: 'Your trainer gives practical eating guidance. For medical conditions or a detailed meal plan, they will suggest working with a registered dietitian.',
        },
    ],
    schema: { name: 'Weight Loss Personal Training in Dubai' },
}

export default content
